import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IFilterState } from '@shared/types/filters';

export const selectFiltersFeature = createFeatureSelector<Readonly<IFilterState>>('filters');

export const selectDateForSingleDate = createSelector(selectFiltersFeature, (state) => ({
    selectedDateForSingleDate: state.selectedDateForSingleDate,
}));

export const selectDateForMultipleDate = createSelector(selectFiltersFeature, (state) => ({
    selectedDateForMultiDate: state.selectedDateForMultiDate,
    calendars: state.calendars,
    businessDate: state.businessDate,
}));

export const selectStoredDates = createSelector(selectFiltersFeature, (state) => ({
    selectedDateForMultiDate: state.selectedDateForMultiDate,
    selectedDateForSingleDate: state.selectedDateForSingleDate,
}));

export const selectBusinessDate = createSelector(selectFiltersFeature, (state) => state.businessDate);

export const selectSingleBusinessDate = createSelector(selectFiltersFeature, (state) => state.singleBusinessDate);

export const selectFilterState = createSelector(selectFiltersFeature, (state) => state);

export const selectView = createSelector(selectFiltersFeature, (state) => state.selectedView);

export const selectStandaloneReportFilters = createSelector(
    selectFiltersFeature,
    (state) => state.standaloneReportFilters,
);

export const selectCombinedSelectFilters = createSelector(selectFiltersFeature, (state) => state.combinedSelectFilters);

export const selectEmployeesFilter = createSelector(selectFiltersFeature, (state) => state.employees);
